// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__UJ5Fn","main":"layout_main__x19xl"};